import { DestroyRef, Injectable } from '@angular/core';
import { QuestionAttemptEntityService } from '@examdojo/question';

@Injectable()
export class ForceSelfGradingOnErrorEffect {
  constructor(
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.enableForcedSelfGrading();
    this.destroyRef.onDestroy(() => this.disableForcedSelfGrading());
  }

  private enableForcedSelfGrading() {
    this.questionAttemptService.setForceSelfGradingOnError(true);
  }

  private disableForcedSelfGrading() {
    this.questionAttemptService.setForceSelfGradingOnError(false);
  }
}
